import { IoCloseCircleOutline } from "react-icons/io5";
import { FormattedMessage, useIntl } from "react-intl";

export const TermAndCondition = ({
  setIsShowTnC,
  isShowTnC,
}: {
  setIsShowTnC: React.Dispatch<React.SetStateAction<boolean>>;
  isShowTnC: boolean;
}) => {
  const intl = useIntl();

  return (
    <>
      {isShowTnC && (
        <div
          className="fixed top-0 bottom-0 left-0 right-0 z-50 flex justify-center py-6 bg-black bg-opacity-30"
          onClick={() => setIsShowTnC(false)}
        >
          <div
            className="max-w-3xl p-6 mx-auto overflow-auto bg-white rounded-lg shadow-md"
            onClick={(e) => e.stopPropagation()}
          >
            <div className="flex items-center justify-between mb-4 ">
              <h1 className="text-3xl font-bold">
                <FormattedMessage id="terms.title" />
              </h1>
              <IoCloseCircleOutline
                size={30}
                className="text-red-600 cursor-pointer hover:text-red-400"
                onClick={() => setIsShowTnC(false)}
              />
            </div>

            {/* Definitions Section */}
            <h2 className="mt-6 text-2xl font-semibold">
              <FormattedMessage id="terms.definitions" />
            </h2>
            <ul className="pl-6 space-y-2 list-disc tnc-list">
              <li>
                <strong>1.1</strong> <FormattedMessage id="terms.definition1" />
              </li>
              <li>
                <strong>1.2</strong> <FormattedMessage id="terms.definition2" />
              </li>
              <li>
                <strong>1.3</strong> <FormattedMessage id="terms.definition3" />
              </li>
              <li>
                <strong>1.4</strong> <FormattedMessage id="terms.definition4" />
              </li>
            </ul>

            {/* Quotation and Scope of Work */}
            <h2 className="mt-6 text-2xl font-semibold">
              <FormattedMessage id="terms.quotation" />
            </h2>
            <ul className="pl-6 space-y-2 list-disc tnc-list">
              <li>
                <strong>2.1</strong> <FormattedMessage id="terms.quotation1" />
              </li>
              <li>
                <strong>2.2</strong> <FormattedMessage id="terms.quotation2" />
              </li>
            </ul>

            {/* Payment Terms */}
            <h2 className="mt-6 text-2xl font-semibold">
              <FormattedMessage id="terms.payment" />
            </h2>
            <ul className="pl-6 space-y-2 list-disc tnc-list">
              <li>
                <strong>3.1</strong> <FormattedMessage id="terms.payment1" />
              </li>
              <li>
                <strong>3.2</strong> <FormattedMessage id="terms.payment2" />
              </li>
              <li>
                <strong>3.3</strong> <FormattedMessage id="terms.payment3" />
              </li>
              <li>
                <strong>3.4</strong> <FormattedMessage id="terms.payment4" />
              </li>
              <li>
                <strong>3.5</strong> <FormattedMessage id="terms.payment5" />
              </li>
            </ul>

            {/* Defect Liability Period */}
            <h2 className="mt-6 text-2xl font-semibold">
              <FormattedMessage id="terms.touchup" />
            </h2>
            <ul className="pl-6 space-y-2 list-disc tnc-list">
              <li>
                <strong>4.1</strong> <FormattedMessage id="terms.touchup1" />
              </li>
              <li>
                <strong>4.2</strong> <FormattedMessage id="terms.touchup2" />
              </li>
            </ul>

            {/* Client Responsibilities */}
            <h2 className="mt-6 text-2xl font-semibold">
              <FormattedMessage id="terms.clientResponsibilities" />
            </h2>
            <ul className="pl-6 space-y-2 list-disc tnc-list">
              <li>
                <strong>5.1</strong>{" "}
                <FormattedMessage id="terms.clientResponsibilities1" />
              </li>
              <li>
                <strong>5.2</strong>{" "}
                <FormattedMessage id="terms.clientResponsibilities2" />
              </li>
              <li>
                <strong>5.3</strong>{" "}
                <FormattedMessage id="terms.clientResponsibilities3" />
              </li>
            </ul>

            {/* Limitation of Liability */}
            <h2 className="mt-6 text-2xl font-semibold">
              <FormattedMessage id="terms.limitation" />
            </h2>
            <ul className="pl-6 space-y-2 list-disc tnc-list">
              <li>
                <strong>6.1</strong> <FormattedMessage id="terms.limitation1" />
              </li>
              <li>
                <strong>6.2</strong> <FormattedMessage id="terms.limitation2" />
              </li>
            </ul>

            {/* Termination */}
            <h2 className="mt-6 text-2xl font-semibold">
              <FormattedMessage id="terms.termination" />
            </h2>
            <ul className="pl-6 space-y-2 list-disc tnc-list">
              <li>
                <strong>7.1</strong>{" "}
                <FormattedMessage id="terms.termination1" />
              </li>
              <li>
                <strong>7.2</strong>{" "}
                <FormattedMessage id="terms.termination2" />
              </li>
            </ul>

            {/* Governing Law and Jurisdiction */}
            <h2 className="mt-6 text-2xl font-semibold">
              <FormattedMessage id="terms.governingLaw" />
            </h2>
            <ul className="pl-6 space-y-2 list-disc tnc-list">
              <li>
                <strong>8.1</strong>{" "}
                <FormattedMessage id="terms.governingLaw1" />
              </li>
              <li>
                <strong>8.2</strong>{" "}
                <FormattedMessage id="terms.governingLaw2" />
              </li>
            </ul>

            {/* Amendments */}
            <h2 className="mt-6 text-2xl font-semibold">
              <FormattedMessage id="terms.amendments" />
            </h2>
            <ul className="pl-6 space-y-2 list-disc tnc-list">
              <li>
                <strong>9.1</strong> <FormattedMessage id="terms.amendments1" />
              </li>
              <li>
                <strong>9.2</strong> <FormattedMessage id="terms.amendments2" />
              </li>
            </ul>

            {/* Construction Duration */}
            <h2 className="mt-6 text-2xl font-semibold">
              <FormattedMessage id="terms.duration" />
            </h2>
            <ul className="pl-6 space-y-2 list-disc tnc-list">
              <li>
                <strong>10.1</strong>{" "}
                <span
                  dangerouslySetInnerHTML={{
                    __html: intl
                      .formatMessage({ id: "terms.duration1" })
                      .replaceAll("\n", "<br/>"),
                  }}
                />
              </li>
              <li>
                <strong>10.2</strong> <FormattedMessage id="terms.duration2" />
              </li>
              <li>
                <strong>10.3</strong> <FormattedMessage id="terms.duration3" />
              </li>
            </ul>

            <p className="mt-6 text-gray-700">
              <FormattedMessage id="terms.acknowledgement" />
            </p>
          </div>
        </div>
      )}
    </>
  );
};
